import { render, staticRenderFns } from "./googlesheets.vue?vue&type=template&id=71a006d4&scoped=true&"
import script from "./googlesheets.vue?vue&type=script&lang=js&"
export * from "./googlesheets.vue?vue&type=script&lang=js&"
import style0 from "./googlesheets.vue?vue&type=style&index=0&id=71a006d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a006d4",
  null
  
)

export default component.exports